import ReactDOM from 'react-dom';
/**
 * Return if a node is a DOM node. Else will return by `findDOMNode`
 */
export default function findDOMNode(node) {
  if (node instanceof HTMLElement) {
    return node;
  }
  return ReactDOM.findDOMNode(node);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-virtual-list/node_modules/rc-util/es/Dom/findDOMNode.js
// module id = null
// module chunks = 